export default {"src":"/_next/static/media/SETUP_GUIDE_COMPLETED_ICON.288505f1.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};